export default __webpack_public_path__ + "static/media/AGB-logo-2017-WhiteWindow.ad10bbf6.jpg";